export const buildGoogleMapsUrl = (destination) => {
    if (!destination)
        return '';
    const encodedDestination = encodeURIComponent(destination);
    // We don't have a Google Maps API key, so we can't use the Directions API.
    // Instead, we'll use the Google Maps URL scheme to open the Google Maps app.
    return `https://www.google.com/maps?hl=en&q=${encodedDestination}&ie=UTF8&t=&z=14&iwloc=B&output=embed`;
};
